import React from 'react'
import { Col, Row } from 'antd'
import cn from 'classnames'

import Wrapper from 'components/Wrapper/Wrapper'

import styles from './HeaderHero.module.css'

interface HeaderHeroProps {
  className?: string
  hasSearch?: boolean
}

const HeaderHero: React.FC<HeaderHeroProps> = ({
  children,
  hasSearch = false,
  className,
}) => {
  return (
    <div
      className={cn(styles.hero, className, {
        [styles.heroHasSearch]: hasSearch,
      })}
    >
      <Wrapper className={styles.heroWrapper}>
        <Row>
          <Col
            xl={{ span: 16, pull: 4, push: 4 }}
            lg={{ span: 20, pull: 2, push: 2 }}
            md={{ span: 20, pull: 2, push: 2 }}
            xs={24}
          >
            {children}
          </Col>
        </Row>
      </Wrapper>
    </div>
  )
}

export default HeaderHero
